import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { NgxMaskConfig, provideEnvironmentNgxMask } from 'ngx-mask';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { routes } from './app.routes';
import { HttpsRequestInterceptor } from './core/interceptors/http-request.interceptor';
import { AuthService } from './shared/services/auth.services';
import { HistoricoNavegacaoService } from './shared/services/historico-navegacao.service';

const maskConfig: Partial<NgxMaskConfig> = {
  thousandSeparator: '.',
  allowNegativeNumbers: false,
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideEnvironmentNgxMask(maskConfig),
    provideHttpClient(withInterceptors([HttpsRequestInterceptor])),
    provideOAuthClient(),
    // Histórico interno para o botão "Voltar" das telas; precisa ver a primeira navegação.
    provideAppInitializer(() => inject(HistoricoNavegacaoService).iniciar()),
    // Resolve o estado OAuth e carrega userInfo/menus antes do render (PGPP-306)
    provideAppInitializer(() => inject(AuthService).initializeAuth()),
  ],
};
